<template>
  <div class="my-1 card">
    <div class="my-0 py-1 card-header text-info">
      <h4 class="my-0 py-1">BAA Details</h4>
    </div>
    <div class="card-body">
      <h4 v-if="BaaDetails.fileInfo">
        BAA Generated successfully!
        <a target="_blank" :href="BaaDetails.fileInfo.webURl">View BAA</a>
      </h4>
      <h4 v-if="!BaaDetails.fileInfo">BAA Generation Failed!</h4>
      <h6 v-if="errorMsg != ''" class="error">
        Not able to create document. Message: "{{ errorMsg }}"
      </h6>
      <button class="btn btn-secondary" @click="goback">Generate Again</button>
      <button class="btn btn-info mx-2" @click="gonext">Generate New</button>
      <router-link
        :to="BaaPath"
        v-if="BaaDetails.fileInfo"
        para
        class="text-info"
        >View BAAs</router-link
      >
    </div>
  </div>
</template>
<script>
import serviceProxy from "../services/index";
import _ from "lodash";
export default {
  name: "generatebaa",
  computed: {},
  created() {
    let that = this;
    let placeHolderValues = this.$store.getters.placeholderValues;
    let token = this.$store.getters.token;
    let country = that.$store.getters.selectedCountry;
    let BAAData = {};
    let baatemplateconfig = that.$store.getters.selectedBaaTemplateConfig;
    BAAData.PlaceHolders = _.map(placeHolderValues, (ph) => {
      return {
        Name: ph.slug,
        Value: ph.Value,
      };
    });
    BAAData.Authority = that.$store.getters.selectedAuthority[0];
    BAAData.Token = token;
    BAAData.fileInfo = baatemplateconfig.fileInfo;
    BAAData.fileType = baatemplateconfig.fileType;
    BAAData.country = country;
    that.BaaDetails = that.$store.getters.sowData;
    if (!that.BaaDetails) {
      that.$root.$emit("progress");
      that.$root.$emit("toast", {
        title: "Creating BAA",
        message: "Knitting everything together to generate the BAA",
      });
      serviceProxy.baa
        .generateBAA(that.$store.getters.token, country, BAAData)
        .then((data) => {
          that.BaaDetails = data.data.data;
          that.$root.$emit("done");
          this.$store.commit("sowData", that.BaaDetails);
          that.$root.$emit("toast", {
            title: "BAA Generated",
            message:
              "BAA generated for the selected country and the given values",
          });
          //tjat.$store.commit("setCreateAgainMode", true);
          confetti.start();
          setTimeout(function () {
            confetti.stop();
          }, 3000);
        })
        .catch((e) => {
          console.log(e);
          that.errorMsg = "";
          that.errorMsg = e.response.data.error
            ? e.response.data.error.message
            : "Generation Failed";
          if (e.response.status == 401) {
            that.errorMsg = "Session Expired!";
          } else if (
            that.errorMsg
              .toLowerCase()
              .indexOf("the resource you are attempting to access is locked") !=
            -1
          ) {
            that.errorMsg =
              "The resource you are attempting to access is open some where. Please close the document and Generate Again.";
          } else if (
            that.errorMsg.toLowerCase().indexOf("accessdenied") != -1
          ) {
            that.errorMsg =
              "User doesn't have the sharepoint access to create BAA";
          }
          that.$root.$emit("toast", {
            title: "BAA Generation Failed",
            message: that.errorMsg,
          });
          that.$root.$emit("done");
        });
    }
  },
  methods: {
    goback: function (oEvent) {
      this.$store.commit("sowData", null);
      this.$router.go(-1);
    },
    gonext: function (oEvent) {
      this.$root.$emit("init");
      this.$router.replace({ path: "choose-document" });
    },
    getTemplate() {},
  },
  data() {
    return {
      BaaDetails: "",
      errorMsg: "",
      BaaPath: "/baandas",
    };
  },
};
</script>
<style scoped>
h3 {
  margin: 40px 0 0;
}
/* ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
} */
a {
  color: #42b983;
}
</style>
